import React from 'react';
import { FC } from 'react';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import { IonHeader, IonModal, IonToolbar } from '@ionic/react';
import { ReactComponent as Close } from '../../../assets/svgs/close.svg';
import { useGetUserPurchasesQuery } from '../../../redux/api/queries/userQueries';
import { theme } from 'components';

interface Props {
  isOpen: boolean;
  setOpen: (b: boolean) => void;
  summary: 'Σε αναμονή' | 'Προς πληρωμή' | 'Πληρωμένες' | 'Έχεις συγκεντρώσει' | null;
  setSummary: (s: 'Σε αναμονή' | 'Προς πληρωμή' | 'Πληρωμένες' | null) => void;
}

const InfoModal: FC<Props> = ({ isOpen, setOpen, summary, setSummary }) => {
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClose = () => {
    setOpen(false);
    setSummary(null);
  };

  const { data: purchases, isLoading: purchasesLoading } = useGetUserPurchasesQuery({ limit: 4 });

  const extractSummary = () => {
    switch (summary) {
      case 'Σε αναμονή':
        return (
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1SmallM" component="h2" color="#6F7787">
              Σε αναμονή
            </Typography>
            <Typography variant="subtitle1SmallM" component="p" color={'#1D2532'}>
              Το ποσό επιστροφής που αντιστοιχεί στις αγορές οι οποίες αναμένεται να επιβεβαιωθούν από τα καταστήματα.
              Μόλις επιβεβαιωθούν, θα εμφανιστούν αυτόματα σε κατάσταση Προς πληρωμή. (Εσύ δεν χρειάζεται να κάνεις
              κάτι!)
            </Typography>
          </Box>
        );
      case 'Προς πληρωμή':
        return (
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1SmallM" component="h2" color="#C07848">
              Προς πληρωμή
            </Typography>
            <Typography variant="subtitle1SmallM" component="p" color={'#1D2532'}>
              Το ποσό επιστροφής που αντιστοιχεί στις επιβεβαιωμένες αγορές σου. Θα το πληρωθείς εφόσον ξεπερνά το
              ελάχιστο ποσό πληρωμής που έχεις επιλέξει στα Στοιχεία πληρωμής σου.
            </Typography>
          </Box>
        );
      case 'Πληρωμένες':
        return (
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1SmallM" component="h2" color="#3CA377">
              Πληρωμένες
            </Typography>
            <Typography variant="subtitle1SmallM" component="p" color={'#1D2532'}>
              Το ποσό επιστροφής που έχεις ήδη πληρωθεί.
            </Typography>
          </Box>
        );
      case 'Έχεις συγκεντρώσει':
        return (
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle1SmallM" component="p" color={'#1D2532'}>
              Το ποσό επιστροφής που έχεις συγκεντρώσει από τις αγορές σου στο Pigogo. Συμπεριλαμβάνονται οι αγορές σε
              κατάσταση Σε αναμονή, Προς πληρωμή και Πληρωμένες.
            </Typography>
          </Box>
        );
      default:
        return <></>;
    }
  };

  return (
    <IonModal
      mode={'ios'}
      style={
        !smDown
          ? { '--height': 'fit-content', '--width': '480px', '--border-radius': '16px' }
          : { '--height': 'fit-content', '--width': '480px', '--border-radius': '16px', paddingInline: '16px' }
      }
      isOpen={isOpen}
      canDismiss={true}
      onDidDismiss={() => handleClose()}
    >
      <IonHeader class="ion-no-border">
        <IonToolbar style={{ '--background': '#FFFFFF', paddingTop: '12px', height: '48px', boxSizing: 'border-box' }}>
          <IconButton
            disableRipple
            className="iconBtn"
            sx={{
              position: 'absolute',
              right: smDown ? 4 : 12,
              top: 0,
              padding: 0,
              width: '24px',
              height: '24px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            onClick={() => handleClose()}
          >
            <Close />
          </IconButton>
        </IonToolbar>
      </IonHeader>
      <Box className="overscroll innerPopup">
        <Box
          sx={{
            paddingInline: smDown ? '24px 12px' : '32px 20px',
            paddingBottom: smDown ? '8px' : '36px',
            paddingTop: smDown ? '0' : '16px',
          }}
        >
          {extractSummary()}
        </Box>
      </Box>
    </IonModal>
  );
};

export default InfoModal;
